import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReportModel } from '../reports.model';
import { ReportsService } from '../reports.service';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { BehaviorSubject } from 'rxjs';
import { QuillEditorComponent } from 'ngx-quill';
import { MatDialog } from '@angular/material/dialog';
import { SuccessBoxComponent } from '../../dialog-box/success-box/success-box.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'logzy-new-report-request-form',
    templateUrl: './new-report-request-form.component.html',
    styleUrls: ['./new-report-request-form.component.scss']
})
export class NewReportRequestFormComponent implements OnInit {
    @Input()
    bindReport = new BehaviorSubject(null);

    @Output()
    closeNewRequestSidePanel = new EventEmitter();

    reportObj: ReportModel;
    disableSaveButton: boolean = false;

    userListUrl = `${ApiRoutes.Company}user_list/?search=::search::&is_internal=1`;
    menuListUrl = `${ApiRoutes.Core}menu_details/?search=::search::`;

    @ViewChild('editor', { static: false }) editor: QuillEditorComponent;

    modules = {};

    constructor(private reportService: ReportsService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
    ) {
        this.modules = {
            toolbar: false
        }
    }

    ngOnInit(): void {
        this.reportObj = new ReportModel();

        this.bindReport.subscribe(item => {
            if (item == null) {
                this.reportObj = new ReportModel();
            }
        })
    }

    closeSidePanel() {
        this.reportObj = new ReportModel();
        this.closeNewRequestSidePanel.emit(false)
    }

    addAllUsers(event) {
        if (event.flag) {
            this.reportObj.user_access = event.option;
        }
    }

    onNewReportRequestSave() {
        this.disableSaveButton = true;
        this.reportService.postNewReportRequest(this.reportObj.getReportSavePayload()).subscribe({
            next: res => {
                this.openSuccessDialog(`Request for new report saved successfully!`, `You will be able to view the report once it is configured.`, null);
                return res;
            },
            error: err => {
                this.disableSaveButton = false;
                if (err.status > 399 && err.status < 500) {
                    this.reportObj.error = { ...err.error };
                } else if (err.status >= 500) {
                    this.snackBar.open("Something went wrong!! Please try again after sometime.", 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                }
                return err;
            }
        });
    }

    openSuccessDialog(label: string, description, btnLabel) {
        const dialogRef = this.dialog.open(SuccessBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: btnLabel }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                this.reportObj = new ReportModel();
                this.closeNewRequestSidePanel.emit(true)
                this.disableSaveButton = false;
            }
        });
    }
}